module.exports = __webpack_public_path__ + "img/GQS-box.5f766ab8.svg";